var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSkeletonArmored = function SvgSkeletonArmored(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "skeleton-armored")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skeleton-armored",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,13 L7,16 L5,16 L5,15 L6,15 L6,14 L5,14 L5,13 L7,13 Z M11,13 L11,14 L10,14 L10,15 L11,15 L11,16 L9,16 L9,13 L11,13 Z M14,13 L14,14 L12,14 L12,13 L14,13 Z M16,8 L16,12 L15,12 L15,9 L12,9 L12,13 L11,13 L11,8 L16,8 Z M15,12 L15,13 L14,13 L14,12 L15,12 Z M9,12 L9,13 L7,13 L7,12 L9,12 Z M4,11 L4,13 L2,13 L2,11 L4,11 Z M10,11 L10,12 L9,12 L9,11 L10,11 Z M7,11 L7,12 L5,12 L5,11 L7,11 Z M9,10 L9,11 L7,11 L7,10 L9,10 Z M10,9 L10,10 L9,10 L9,9 L10,9 Z M7,9 L7,10 L6,10 L6,9 L7,9 Z M3,2 L3,3 L4,3 L4,9 L5,9 L5,10 L0,10 L0,9 L1,9 L1,3 L2,3 L2,2 L3,2 Z M3,4 L2,4 L2,9 L3,9 L3,4 Z M11,0 L11,1 L12,1 L12,2 L13,2 L13,6 L11,6 L11,8 L10,8 L10,7 L9,7 L9,8 L7,8 L7,7 L6,7 L6,8 L5,8 L5,5 L7,5 L7,2 L6,2 L6,3 L5,3 L5,2 L4,2 L4,1 L5,1 L5,0 L11,0 Z M9,5 L7,5 L7,6 L9,6 L9,5 Z M10,2 L9,2 L9,5 L11,5 L11,3 L10,3 L10,2 Z",
    fill: "#000000"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkeletonArmored, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/skeleton-armored.bd6afb2c.svg";
export { ForwardRef as ReactComponent };